import { createContext, useContext, useState } from "react";

const StateContext = createContext();

export const StateProvider = ({ children }) => {
    const [states, setStates] = useState({
    //    page1: { query1: "", query2: "" },
    //    page2: { query1: "", query2: "" },
    });

    const updateStateProvider = (page, newValues) => {
        setStates((prev) => ({
            ...prev,
            /// [page]: { ...prev[page], ...newValues },
            [page]: newValues,
        }));
    };

    return (
        <StateContext.Provider value={{ states, updateStateProvider }}>
            {children}
        </StateContext.Provider>
    );
};

export const useStateProvider = () => useContext(StateContext);
